import React, { Component, createRef } from 'react'
import { Button, TableRow, TableCell } from '@material-ui/core'

// utils
import { onChangeEditHOF } from '../../utils/common'

import { EditableTextField } from '../common/EditableComponents'
import SubscriptionModal from '../Modal/SubscriptionModal'
//actions
import { updateSubscriptionDefaultPayment } from '../../actions/company'
export default class SubscriptionItem extends Component {
  subscriptionModal = createRef()

  onChange = onChangeEditHOF(this.props.onChange)

  openSubscriptionModalModal = () => {
    this.subscriptionModal.current.handleClickOpen()
  }

  onSave = () => {
    this.props.onSave((response) => this.props.disableEdit())
  }

  onCancel = () => {
    this.props.onCancel()
  }

  onChange = (key) => (e) => {
    this.setState({
      [key]: e.target.value,
    })
  }

  setSubscriptionDefaultSource = (selectedSource) => {
    const { subscription } = this.props
    const data = {
      subscriptionId: subscription.id,
      sourceId: selectedSource,
    }
    this.props.dispatch(updateSubscriptionDefaultPayment(data)).then((res) => {
      this.subscriptionModal.current.handleClose()
      this.props.getCustomer()
    })
  }

  render() {
    const { data = {}, editMode, subscription, sourceList } = this.props

    return (
      <TableRow>
        <TableCell className="cell-wrap-word">
          <EditableTextField
            valueToRender={data.name}
            editMode={editMode}
            value={data.name}
            type="text"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </TableCell>
        <TableCell className="cell-wrap-word" style={{ textAlign: 'center' }}>
          <EditableTextField
            valueToRender={data.quantity}
            editMode={editMode}
            value={data.quantity}
            type="text"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </TableCell>
        <TableCell className="cell-wrap-word" style={{ textAlign: 'center' }}>
          <EditableTextField
            valueToRender={data.totalCost}
            editMode={editMode}
            value={data.totalCost}
            type="text"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </TableCell>
        <TableCell className="cell-wrap-word" style={{ textAlign: 'center' }}>
          <EditableTextField
            valueToRender={data.source}
            editMode={editMode}
            value={data.source}
            type="text"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </TableCell>
        <TableCell className="cell-wrap-word padding-small" style={{ textAlign: 'right' }}>
          <Button
            size="small"
            variant="outlined"
            color="primary"
            className="margin"
            onClick={this.openSubscriptionModalModal}
          >
            Edit
          </Button>
        </TableCell>
        <SubscriptionModal
          ref={this.subscriptionModal}
          addCard={this.addCard}
          onError={this.onError}
          subscription={subscription}
          sourceList={sourceList}
          onConfirm={this.setSubscriptionDefaultSource}
          sourceId={data.sourceId}
          size="lg"
        />
      </TableRow>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Billing/SubscriptionItem.js